module.exports = __webpack_public_path__ + "static/media/global-assets-logo-logo-stacked-black.11c9d33d.svg";